import { useRequest, useView } from '@10000/react'
import { InputScreen, onboardBackground, useBackground, useShell, useStack } from '../../layout'
import { Box } from '../../widgets'
import { SelectableList } from '../../forms'
import { Teams } from './'
import { OnboardConfirmation } from '../teamLead'
import { isPartner, roles } from '../../../lookups'

export const TeamRole = ({ active, id, organisationId }) => {
  const request = useRequest('tenant')
  const { push } = useStack()
  const { teams, user: { admin }, subscription } = useView('tenant')
  const { role } = teams.find(x => x.id === id) || {}

  useShell({
    active,
    mode: 'progress narrow',
    ...(admin ? isPartner(subscription) ? { step: 8, max: 8 } : { step: 6, max: 6 } : { step: 4, max: 4 })
  })
  useBackground().set(mobile => ({ active, fade: !admin, ...onboardBackground(admin, mobile) }))

  const selectRole = ({ role }) => {
    if(role !== undefined) {
      return request('teamUpdated', { id, role }).then(() => push(admin ? Teams : OnboardConfirmation, { props: { organisationId } }))
    }
  }

  return (
    <InputScreen
      fade
      fadeColour={!admin && 'blue'}
      onSubmit={selectRole}
      formValues={{ role }}
      footerButton="Next"
      title="Type of team"
      description="Within your organisation, what function does your team fulfil, or what &quot;department&quot; are you in?"
    >
      <Box className="scrolling-list">
        <SelectableList name="role" list={roles.map(({ name }) => name)}/>
      </Box>
    </InputScreen>
  )
}